import classNames from 'classnames';
import { useRef, useState } from 'react';

import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import { faCheckCircle } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const rootCss = ({ breakpoints, palette, spacing, typography }) => ({
  display: 'flex',
  alignItems: 'start',
  padding: spacing(4),
  backgroundColor: palette.grey[100],

  '.OCPBP-right': {
    padding: spacing(0, 6, 0, 2.5),
    '& * small': { color: palette.grey[500], fontWeight: typography.fontWeightRegular },
  },
  '.OCPBP-promoCode': { display: 'flex', justifyContent: 'space-between', marginTop: spacing(1) },
  '.OCPBP-promoCodeField': {
    height: 32,
    padding: spacing(0.5, 1),
    ...typography.subtitle1,
    '&.OCPBP-promoCodeField_copied': {
      color: palette.primary.main,
    },
  },
  '.OCPBP-copied': {
    display: 'flex',
    flexDirection: 'row',
    color: palette.primary.main,
    alignItems: 'center',
    justifyContent: 'space-evenly',
    marginRight: spacing(-2),
    '& *': { margin: spacing(0, 0.5) },
  },
  '.OCPBP-copyBtn': { marginLeft: spacing(0.5) },
  '.OCPBP-outlined': {
    fontSize: 72,
    color: palette.primary.main,
    WebkitTextFillColor: 'transparent',
    WebkitTextStrokeWidth: '2px',
    WebkitTextStrokeColor: palette.primary.main,
  },
  '.OCPBP-grey': {
    fontWeight: typography.fontWeightBlack,
    color: palette.grey[700],
    marginLeft: spacing(0.5),
    marginTop: spacing(-1),
  },

  [breakpoints.only('xs')]: {
    flexDirection: 'column',
    padding: spacing(2, 1),
    '.OCPBP-promoLabel': { marginLeft: spacing(4) },
  },
});

export default function OnlineCoursePurchaseBundlePromo(props) {
  const {
    promo: { amount, code },
  } = props;

  const codeInput = useRef(null);
  const [copied, setCopied] = useState(false);

  return (
    <div css={rootCss}>
      <div className="OCPBP-promoLabel">
        <Typography className="OCPBP-outlined" variant="h1">
          <strong>{amount}</strong>
        </Typography>
        <Typography className="OCPBP-grey" variant="h5">
          % OFF
        </Typography>
      </div>
      <div className="OCPBP-right">
        <Typography variant="h6">
          Bundle & Save! <small>[limited time only]</small>
        </Typography>
        <Typography>Get {amount}% off your next course with promo code:</Typography>
        {promoCodeField()}
      </div>
    </div>
  );

  function promoCodeField() {
    return (
      <div className="OCPBP-promoCode">
        <TextField
          fullWidth
          readOnly
          slotProps={{
            input: {
              classes: {
                input: classNames('OCPBP-promoCodeField', copied && 'OCPBP-promoCodeField_copied'),
              },
            },

            htmlInput: { ref: codeInput },
          }}
          value={code}
        />
        {!copied ?
          <Button className="OCPBP-copyBtn" onClick={onCopyCode} variant="outlined">
            Copy
          </Button>
        : <Typography className="OCPBP-copied">
            <FontAwesomeIcon icon={faCheckCircle} /> Copied!
          </Typography>
        }
      </div>
    );
  }

  function onCopyCode() {
    codeInput.current.select();
    document.execCommand('copy');
    setCopied(true);
  }
}
